import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import googleLogo from '../../assets/img/Google.png';

interface Props {
    // signIn: (provider: string, data: any) => void;
    signIn: any;
    label?: string;
}

const GoogleLoginComponent: React.FC<Props> = ({ signIn, label = 'Sign in with Google' }) => {
    const handleLoginSuccess = (credentialResponse: any) => {
        const idToken = credentialResponse.credential;
        if (idToken) {
            const decoded = jwtDecode(idToken);
            const id_token = credentialResponse.credential;
            signIn('google', { id_token, ...decoded });
        }
    };

    const handleLoginFailure = () => {
        console.log('Login Failed');
    };

    return (
        <div className="google-login-container">
            <button
                onClick={() => {
                    const googleBtn = document.querySelector('[aria-labelledby="button-label"]');
                    if (googleBtn) {
                        (googleBtn as HTMLElement).click();
                    }
                }}
                className="btn login-btn google-btn pointer-events-all text-center w-100"
                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#f8f9fa')}
                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'white')}
            >
                <span className="google-icon">
                    <img loading='lazy'src={googleLogo} width={20} alt="Google logo" />
                </span>
                <span className="google-text-margin social-btn-text">{label}</span>
            </button>
            <div style={{ display: 'none' }}>
                <GoogleLogin onSuccess={handleLoginSuccess} onError={handleLoginFailure} />
            </div>
        </div>
    );
};

export default GoogleLoginComponent;
